import React from "react";
import Layout from "../components/organisms/Layout";
import DynamicComponent from "../components/molecules/DynamicComponent";
import axios from "axios";
import Storyblok, { useStoryblok } from "../utils/storyblok";



export default function Privacy({ iubenda, story },) {


  return (
    <section>
      <style global jsx >{`
        .prose-xl h1,h2,h3,h4,h5,h6,li,ul,ol  {
          font-size: 18px!important;
        }
        .prose-xl  h1,h2,h3,h4,h5,h6 {
            text-transform: uppercase;
        }
        .prose-xl p {
          margin-top: 0;
          font-size: 18px;
          margin-bottom: 2;
        }
        .prose-xl ul > li {
          padding-left: 0;
        }
        .prose-xl li {
          margin-top:0;
          margin-bottom:0;
        }
        .prose-xl > ul > li > *:last-child {
          margin-bottom: 0;
        }
        .prose-xl > ul > li > *:first-child {
          margin-top: 0em;
        }
        .prose-xl > ul > li p {
          margin-top: 0;
          margin-bottom: 0;
        }
        ol, ul {
          list-style-position: inside;
        }
        li {
          list-style-position: inside!important;
          list-style: circle;
        }
        li > p {
          list-style-position: inside!important;
          list-style: dot;
          display: inline;
        }
      `}
      </style>
      <article className="prose-xl leading-snug w-full lg:w-1/2 py-8"
        dangerouslySetInnerHTML={{
          __html: iubenda.content
        }} >
      </article>
    </section>
  );
}



export async function getStaticProps(context, params, preview = false) {
  let slug = "/terms-of-service";
  let sbParams = {
    version: "draft", // or 'draft'
  };

  if (preview) {
    sbParams.version = "draft";
    sbParams.cv = Date.now();
  }

  let { data } = await Storyblok.get(`cdn/stories/${slug}`, sbParams);

  const res = await fetch(`https://www.iubenda.com/api/nutzungsbedingungen/32683154/no-markup`)
  const iubenda = await res.json()

  if (!iubenda) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      iubenda

    }, // will be passed to the page component as props
  }
}
